import type { SyntheticEvent } from 'react';

/**
 * Spread onto `<img>` / `<video>` so bitmaps fade in (200ms) once decoded
 * instead of popping: `className={MEDIA_FADE_IN_CLASS} onLoad={revealMedia}`.
 * Errors reveal too so alt text stays readable.
 */
export const MEDIA_FADE_IN_CLASS =
  'opacity-0 transition-opacity duration-200 ease-out data-loaded:opacity-100';

export function revealMedia(event: SyntheticEvent<HTMLElement>) {
  event.currentTarget.dataset.loaded = '';
}
